<template>
  <v-container v-if="!snapshot" fluid fill-height>
    <v-row align="center" justify="center">
      <LoadingIndicator />
    </v-row>
  </v-container>

  <v-container v-else fluid fill-height class="main-widget ma-1 pa-0">
    <v-container v-if="showAsTable" fluid class="mobile-view">
      <v-row no-gutters class="flex-nowrap">
        <v-col>
          <Clock :date="snapshot.date" :interval="snapshot.interval" :is-mobile="true" />
        </v-col>
      </v-row>
      <v-spacer style="height: 2em" />
      <Nem />
      <v-spacer style="height: 2em" />
      <MobileTable :current="currentPrices" />
      <v-spacer style="height: 2em" />
      <LegendComponent />
    </v-container>

    <v-container v-else fluid fill-height class="main-widget ma-0 pa-0">
      <v-dialog :value="isWaiting" fullscreen>
        <v-container fluid fill-height style="background-color: rgba(0, 0, 0, 0.5)">
          <v-row justify="center" align="center">
            <LoadingIndicator />
          </v-row>
        </v-container>
      </v-dialog>

      <v-row no-gutters class="flex-nowrap" align-content="center">
        <v-spacer />
        <v-col cols="5" class="ma-auto">
          <Clock :date="snapshot.date" :interval="snapshot.interval" />
        </v-col>
        <v-col cols="auto" class="horizontal-spacer" />
        <v-col cols="5">
          <Region name="QLD" :current="currentPrices!.regions!['QLD1']" :previous="previousPrices!.regions!['QLD1']" :ap="snapshot.administeredRegions!.includes('QLD1')" />
        </v-col>
        <v-spacer />
      </v-row>

      <v-row v-if="showInterconnectors" no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5" class="vertical-spacer" />
        <v-col cols="auto" class="horizontal-spacer" />
        <v-col cols="5" class="vertical-spacer">
          <v-row align="center" justify="center">
            <v-col cols="auto" class="mt-0 pt-0 mb-0 pb-0">
              <Interconnector name="NSW1-QLD1" :current="currentPrices!.interconnectors!['NSW1-QLD1']" :previous="previousPrices!.interconnectors!['NSW1-QLD1']" flip />
            </v-col>
            <v-col cols="auto" class="mt-0 pt-0 mb-0 pb-0">
              <Interconnector name="N-Q-MNSP1" :current="currentPrices!.interconnectors!['N-Q-MNSP1']" :previous="previousPrices!.interconnectors!['N-Q-MNSP1']" />
            </v-col>
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row v-else class="pb-3" />

      <v-row no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5" class="ma-auto">
          <Nem />
        </v-col>

        <v-col v-if="showInterconnectors" cols="auto" align-self="end" class="horizontal-spacer">
          <v-row align="center" justify="center" no-gutters>
            <v-col>
              <Interconnector name="NSW1-SA1" :current="currentPrices!.interconnectors!['NSW1-SA1']" :previous="previousPrices!.interconnectors!['NSW1-SA1']" vertical flip :rotation="-45" />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else class="horizontal-spacer ma-0" cols="auto" />

        <v-col cols="5">
          <Region name="NSW" :current="currentPrices!.regions!['NSW1']" :previous="previousPrices!.regions!['NSW1']" :ap="snapshot.administeredRegions!.includes('NSW1')" />
        </v-col>
        <v-spacer />
      </v-row>

      <v-row v-if="showInterconnectors" no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5" class="vertical-spacer" />
        <v-col cols="auto" class="horizontal-spacer" />
        <v-col cols="5" class="vertical-spacer">
          <v-row align="center" justify="center">
            <v-col cols="auto" class="mt-0 pt-0 mb-0 pb-0">
              <Interconnector name="VIC1-NSW1" :current="currentPrices!.interconnectors!['VIC1-NSW1']" :previous="previousPrices!.interconnectors!['VIC1-NSW1']" />
            </v-col>
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row v-else class="pb-3" />

      <v-row no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5">
          <Region name="SA" :current="currentPrices!.regions!['SA1']" :previous="previousPrices!.regions!['SA1']" :ap="snapshot.administeredRegions!.includes('SA1')" />
        </v-col>
        <v-col v-if="showInterconnectors" cols="auto" class="horizontal-spacer ma-0 pt-6">
          <v-row align="center" justify="center" no-gutters>
            <v-col>
              <Interconnector name="V-S-MNSP1" :current="currentPrices!.interconnectors!['V-S-MNSP1']" :previous="previousPrices!.interconnectors!['V-S-MNSP1']" vertical flip />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" no-gutters>
            <v-col>
              <Interconnector name="V-SA" :current="currentPrices!.interconnectors!['V-SA']" :previous="previousPrices!.interconnectors!['V-SA']" vertical />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else class="horizontal-spacer ma-0" cols="auto" />
        <v-col cols="5">
          <Region name="VIC" :current="currentPrices!.regions!['VIC1']" :previous="previousPrices!.regions!['VIC1']" :ap="snapshot.administeredRegions!.includes('VIC1')" />
        </v-col>
        <v-spacer />
      </v-row>

      <v-row v-if="showInterconnectors" no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5" class="vertical-spacer" />
        <v-col cols="auto" class="horizontal-spacer" />
        <v-col cols="5" class="vertical-spacer">
          <v-row align="center" justify="center">
            <v-col cols="auto" class="mt-0 pt-0 mb-0 pb-0">
              <Interconnector name="T-V-MNSP1" :current="currentPrices!.interconnectors!['T-V-MNSP1']" :previous="previousPrices!.interconnectors!['T-V-MNSP1']" />
            </v-col>
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row v-else class="pb-3" />

      <v-row no-gutters class="flex-nowrap">
        <v-spacer />
        <v-col cols="5" class="ma-auto">
          <LegendComponent />
        </v-col>
        <v-col cols="auto" class="horizontal-spacer" />
        <v-col cols="5">
          <Region name="TAS" :current="currentPrices!.regions!['TAS1']" :previous="previousPrices!.regions!['TAS1']" :ap="snapshot.administeredRegions!.includes('TAS1')" />
        </v-col>
        <v-spacer />
      </v-row>
    </v-container>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/stores/main';
import { storeToRefs } from 'pinia';
import { useDisplay } from 'vuetify';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import MobileTable from '@/components/MobileTable.vue';
import Clock from '@/components/Clock.vue';
import Region from '@/components/Region.vue';
import Interconnector from '@/components/InterconnectorComponent.vue';
import Nem from '@/components/Nem.vue';
import LegendComponent from '@/components/Legend.vue';

const route = useRoute();
const store = useStore();
const { isWaiting, snapshot, currentPrices, previousPrices } = storeToRefs(store);

const { mobile } = useDisplay();
const modeOverride = ref<string | undefined>('');
const showAsTable = computed(() => (modeOverride.value === undefined && mobile.value) || modeOverride.value === 'mobile' || modeOverride.value === 'table');

const showInterconnectors = ref(true);

watchEffect(() => {
  const dispatchInterval = route.query.dispatchInterval?.toString();
  const isRealTime: boolean = dispatchInterval === undefined || route.query.isRealTime === 'true';
  store.loadSnapshots(dispatchInterval, isRealTime);
});

watchEffect(() => {
  modeOverride.value = route.query.mode?.toString();
});

watchEffect(() => {
  showInterconnectors.value = route.query.interconnectors !== 'false';
});
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.horizontal-spacer {
  width: 52px;
}

.mobile-view {
  font-size: 0.7em;
}
</style>
